function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PostPublishTemplate = require('./post-publish.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../../tx_location'),
  readTransactionLocation = _require2.readTransactionLocation;
function escapeHtml(text) {
  return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
var PostPublishFlow = /*#__PURE__*/function () {
  function PostPublishFlow(app, mod, mainUi) {
    var _this = this;
    _classCallCheck(this, PostPublishFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.open = false;
    this.publishedTx = null;
    this.p2shAddress = '';
    this.p2shHash = '';
    this.p2shLink = '';
    this.blockId = null;
    this.txOrdinal = null;
    this.blockedRoot = null;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.open) {
        _this.hide();
      }
    };
  }

  /**
   * Final hand-off after on-chain confirmation — not part of the publish wizard.
   */
  return _createClass(PostPublishFlow, [{
    key: "openOverlay",
    value: function openOverlay() {
      var _this$publishedTx;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$tx = _ref.tx,
        tx = _ref$tx === void 0 ? null : _ref$tx,
        _ref$p2shAddress = _ref.p2shAddress,
        p2shAddress = _ref$p2shAddress === void 0 ? '' : _ref$p2shAddress,
        _ref$p2shHash = _ref.p2shHash,
        p2shHash = _ref$p2shHash === void 0 ? '' : _ref$p2shHash,
        _ref$blockId = _ref.blockId,
        blockId = _ref$blockId === void 0 ? null : _ref$blockId,
        _ref$txOrdinal = _ref.txOrdinal,
        txOrdinal = _ref$txOrdinal === void 0 ? null : _ref$txOrdinal,
        _ref$blk = _ref.blk,
        blk = _ref$blk === void 0 ? null : _ref$blk;
      this.publishedTx = tx;
      this.p2shAddress = p2shAddress || '';
      this.p2shHash = p2shHash || '';
      var location = readTransactionLocation(tx, blk);
      this.blockId = blockId != null && String(blockId) !== '' ? String(blockId) : location.blockId != null ? location.blockId.toString() : null;
      this.txOrdinal = txOrdinal != null && String(txOrdinal) !== '' ? String(txOrdinal) : location.txOrdinal != null ? location.txOrdinal.toString() : null;
      this.p2shLink = typeof this.mod.buildP2shShareLink === 'function' ? this.mod.buildP2shShareLink({
        p2shHash: this.p2shHash,
        p2shAddress: this.p2shAddress,
        blockId: this.blockId,
        transactionId: ((_this$publishedTx = this.publishedTx) === null || _this$publishedTx === void 0 ? void 0 : _this$publishedTx.signature) || location.transactionId || '',
        tx: this.publishedTx
      }) : this.p2shAddress;
      this.open = true;
      this.show(PostPublishTemplate.overlay({
        p2shLink: escapeHtml(this.p2shLink)
      }));
      this.bindEvents();
    }
  }, {
    key: "show",
    value: function show(html) {
      var _this2 = this;
      document.body.classList.add('rs-publish-modal-open');
      this.blockedRoot = document.querySelector('main.rustscript');
      if (this.blockedRoot) {
        this.blockedRoot.inert = true;
      }
      document.addEventListener('keydown', this.onEscapeKey);
      this.overlay.show(html, function () {
        _this2.onOverlayClosed();
      });
      applyPublishOverlayShell(this.overlay);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.open) {
        this.overlay.close();
      }
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      if (this.blockedRoot) {
        this.blockedRoot.inert = false;
        this.blockedRoot = null;
      }
      this.open = false;
      this.publishedTx = null;
      this.p2shAddress = '';
      this.p2shHash = '';
      this.p2shLink = '';
      this.blockId = null;
      this.txOrdinal = null;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _root$querySelector,
        _this3 = this,
        _root$querySelector2,
        _root$querySelector3;
      var root = document.querySelector('.rs-post-publish');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="post-publish-download"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        var tx = _this3.publishedTx;
        if (!tx) {
          return;
        }
        try {
          _this3.mod.exportTransaction(tx, {
            prefix: 'rustscript-tx',
            block_id: _this3.blockId,
            transaction_id: _this3.txOrdinal
          });
        } catch (err) {
          console.error('RustScript: failed to export confirmed transaction', err);
          alert((err === null || err === void 0 ? void 0 : err.message) || 'Could not export the transaction.');
        }
      });
      (_root$querySelector2 = root.querySelector('.rs-post-publish-link')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('focus', function (event) {
        var _event$target$select, _event$target;
        (_event$target$select = (_event$target = event.target).select) === null || _event$target$select === void 0 || _event$target$select.call(_event$target);
      });
      (_root$querySelector3 = root.querySelector('[data-action="post-publish-copy-link"]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _root$querySelector4;
        var btn, link, icon, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              btn = root.querySelector('[data-action="post-publish-copy-link"]');
              link = ((_root$querySelector4 = root.querySelector('.rs-post-publish-link')) === null || _root$querySelector4 === void 0 ? void 0 : _root$querySelector4.value) || _this3.p2shLink || _this3.p2shAddress;
              if (!(!link || !btn)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return navigator.clipboard.writeText(link);
            case 2:
              btn.classList.add('is-copied');
              icon = btn.querySelector('.rs-copy-btn-icon');
              if (icon) {
                icon.classList.remove('fa-copy');
                icon.classList.add('fa-check');
              }
              window.clearTimeout(_this3._copyResetTimer);
              _this3._copyResetTimer = window.setTimeout(function () {
                btn.classList.remove('is-copied');
                if (icon) {
                  icon.classList.remove('fa-check');
                  icon.classList.add('fa-copy');
                }
              }, 1400);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      })));
    }
  }]);
}();
module.exports = PostPublishFlow;